import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { db } from '../config/firebase';
import { doc, getDoc, setDoc } from 'firebase/firestore';

export default function ManageLabs() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [showLabForm, setShowLabForm] = useState(false);
  const [labForm, setLabForm] = useState({ week: '', group: '', title: '', pdfUrl: '', status: 'closed' });
  const [currentWeek, setCurrentWeek] = useState(1);
  const [filterGroup, setFilterGroup] = useState('all');
  const [savingLabId, setSavingLabId] = useState(null);
  const [statusMessage, setStatusMessage] = useState(null);
  
  const groups = ['Alpha', 'Beta', 'Charlie', 'Delta', 'Echo'];
  
  const initialLabs = [
    // Week 1
    { id: 1, week: 1, group: 'Alpha', title: 'Foundation Concepts - Alpha', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSdTt0mAxUmhIcUnhqfyuMQslMPfCq1pHEsJ0KMDUnecpDMkIA/viewform?usp=sharing&ouid=108026927187778950974', status: 'released' },
    { id: 2, week: 1, group: 'Beta', title: 'Foundation Concepts - Beta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSevWdz-eKrsGTgKct1qIIaJzlvGBdJREDG_T_5y1vq3fkzUow/viewform?usp=sharing&ouid=108026927187778950974', status: 'released' },
    { id: 3, week: 1, group: 'Charlie', title: 'Foundation Concepts - Charlie', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLScNphURm1i-JXTdaQys8e66phsNGqYihalfyF6Bq1uCGgQSfw/viewform?usp=sharing&ouid=108026927187778950974', status: 'released' },
    // Week 2
    { id: 4, week: 2, group: 'Alpha', title: 'Intermediate Topics - Alpha', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSc6hM4TOdOLYXtNSTsI-wYIwoyLanUTNOHJq-pZChicuZfsVA/viewform?usp=sharing&ouid=108026927187778950974', status: 'released' },
    { id: 5, week: 2, group: 'Beta', title: 'Intermediate Topics - Beta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSeuhvjduiGD4sNZGEKNmeApdv5BfnCJyAoIx_c5k3URH8eBxA/viewform?usp=sharing&ouid=108026927187778950974', status: 'released' },
    { id: 6, week: 2, group: 'Charlie', title: 'Intermediate Topics - Charlie', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSePd4Z3SxoSfcdo-Oln49gNfu6xjwGdP3becWaEcIQnew1RUw/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 3
    { id: 7, week: 3, group: 'Alpha', title: 'Advanced Techniques - Alpha', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSegvV7vlqZrdN7riuDIl59ljBDqxteCRJfkIjOFICGfT9vfVQ/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 8, week: 3, group: 'Beta', title: 'Advanced Techniques - Beta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSf1YpZGzqeYtWfQBYwVwHhkj3iIE7tqCySIHYiqZejQn-Vq7g/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 9, week: 3, group: 'Charlie', title: 'Advanced Techniques - Charlie', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSegvV7vlqZrdN7riuDIl59ljBDqxteCRJfkIjOFICGfT9vfVQ/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 4
    { id: 10, week: 4, group: 'Alpha', title: 'Week 4 - Alpha', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfwNM2emEWz8V6HakptBiKj3KcIlCJY1CaGb9QvaDeBblg0qA/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 11, week: 4, group: 'Beta', title: 'Week 4 - Beta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSck2nLDk85QhYE71AdWB7u1bGTZ3Dx7eR2_FDohv6aZgs3nbg/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 12, week: 4, group: 'Charlie', title: 'Week 4 - Charlie', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfrPN6HX4_Yy-qaW5ourBqHTCaelnWj_3EsbUa4Q3RydVBHGA/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 5
    { id: 13, week: 5, group: 'Alpha', title: 'Week 5 - Alpha', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLScpjZCuEWVjY4BZEEbqt-GpVVyB5jsD_TxHj83zGydpu69-SQ/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 14, week: 5, group: 'Beta', title: 'Week 5 - Beta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSevTLNe4xdZJHAAayRWLTTVYqwMgZjfn7qDdUFodwwF-sqAfA/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 15, week: 5, group: 'Charlie', title: 'Week 5 - Charlie', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSe1_47PjcAj7Qu_qXCifc4p7ROPE5hwpcG_vU2dgIZdO9d-Qw/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 6
    { id: 16, week: 6, group: 'Alpha', title: 'Week 6 - Alpha', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSejALLygBRNLX30MoncimumzIzk3XEX5-JT8oYzQbslGwsNUA/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 17, week: 6, group: 'Beta', title: 'Week 6 - Beta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSdAT-nCeh3cU84JHYFrruNdD4pHZW4itUELFeYOAXHTfwkrkA/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 18, week: 6, group: 'Charlie', title: 'Week 6 - Charlie', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSedfcf3AWmzMCpvMkLPjjQO_DPA408xU1KNZaqxIBhzh3BIOA/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 7
    { id: 19, week: 7, group: 'Alpha', title: 'Week 7 - Alpha', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfWEjZWBg0d-AY-sRJV0rgy4XhykU7LR5XpXFHWDFJ0Ckr8VQ/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 20, week: 7, group: 'Beta', title: 'Week 7 - Beta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSf9zrVmBT1zxs0ddSrtxbO7nb-0LskFoukBSIKH3SurORdvlQ/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 21, week: 7, group: 'Charlie', title: 'Week 7 - Charlie', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLScr-G7vMhZPihWBhNxe7DJOuax5i_8yl1f33EVQxBxchTg-Fw/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 8
    { id: 22, week: 8, group: 'Alpha', title: 'Week 8 - Alpha', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSdwDy0ehO93323SjBhVJWcbAbm-ILXILQbz-CPURslXJwd0Dw/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 23, week: 8, group: 'Beta', title: 'Week 8 - Beta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSdB1F2kw-L23KxCvMqkpdmFb3ZsUlVepdt1Nnyi62UJmZjtKQ/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 24, week: 8, group: 'Charlie', title: 'Week 8 - Charlie', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSevgBY55j1psbzxJ9rshwGfH-ZQa2Usgmvte2_k__r7nYcjwA/viewform?usp=publish-editor', status: 'closed' },
    // Week 9
    { id: 25, week: 9, group: 'Alpha', title: 'Week 9 - Alpha', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSdbckIRpPU9gdne7yZC3MEAMfTxjaXUXIQemCGNjDGwG0ycdg/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 26, week: 9, group: 'Beta', title: 'Week 9 - Beta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLScsWFEU5VCiE6aQTfgCQNK73K-INg_REzhjMRrmeTsR1mjciA/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    { id: 27, week: 9, group: 'Charlie', title: 'Week 9 - Charlie', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSdaBIIbJxAFSCdUW-d_Q1EmBmIFrscEe89fo3h7rMkRRYDvug/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 1 - Delta
    { id: 28, week: 1, group: 'Delta', title: 'Foundation Concepts - Delta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSdQxJ2jZ99U3P4WjrezVnwwA9Q6RcbZxikYJikfUw7DqznFVQ/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 2 - Delta
    { id: 29, week: 2, group: 'Delta', title: 'Intermediate Topics - Delta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfno0zW3qVANyeJFfKB2FF5lW1XNZ-VZomYPRxjTw7ekG9HmA/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 3 - Delta
    { id: 30, week: 3, group: 'Delta', title: 'Advanced Techniques - Delta', pdfUrl: 'https://docs.google.com/forms/d/1EzLqORopaJ7rLQZBhbTTObNBV-gDBCGRoAa8LpMaVLI/edit', status: 'closed' },
    // Week 4 - Delta
    { id: 31, week: 4, group: 'Delta', title: 'Week 4 - Delta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSeNHPtj1IO19pFk1r7vtL3jI3zpPfqm8iiJpAvJuIFNAj8CWw/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 5 - Delta
    { id: 32, week: 5, group: 'Delta', title: 'Week 5 - Delta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSetyeifdAbPF8pIhFGK3rJ6nKsnEy_GfN4oUWN57I-NOz7YAw/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 6 - Delta
    { id: 33, week: 6, group: 'Delta', title: 'Week 6 - Delta', pdfUrl: 'https://docs.google.com/forms/d/1M-4KoDyZIGai0p77vPgVxOzHG5zPoBqpiAwDUXQzMIM/edit', status: 'closed' },
    // Week 7 - Delta
    { id: 34, week: 7, group: 'Delta', title: 'Week 7 - Delta', pdfUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSfHjma9_-peL0m8tGOViiF8-sbGxAnO7cDBK7PQv_7kXH9r7Q/viewform?usp=sharing&ouid=108026927187778950974', status: 'closed' },
    // Week 8 - Delta
    { id: 35, week: 8, group: 'Delta', title: 'Week 8 - Delta', pdfUrl: 'https://docs.google.com/forms/d/1Ocihn9wy1VLy_MJhBLHxRIYHry597DryY6ERl8GxOvA/edit', status: 'closed' }
  ];
  
  const [labs, setLabs] = useState(initialLabs);
  
  const weeks = [...new Set(labs.map(lab => lab.week))].sort((a, b) => a - b);

  // Load lab statuses from Firestore on mount
  useEffect(() => {
    const loadLabStatuses = async () => {
      if (!user || !user.id) {
        console.log('User not available yet');
        return;
      }
      
      try {
        console.log('Loading lab statuses for user:', user.id);
        const statusRef = doc(db, 'instructors', user.id, 'labStatuses', 'statuses');
        const statusDoc = await getDoc(statusRef);
        
        if (statusDoc.exists()) {
          const savedStatuses = statusDoc.data();
          console.log('Found saved statuses:', savedStatuses);
          // Update labs with saved statuses from Firestore
          setLabs(prevLabs => 
            prevLabs.map(lab => ({
              ...lab,
              status: savedStatuses[`lab_${lab.id}`] || lab.status
            }))
          );
        } else {
          console.log('No saved statuses found in Firestore');
        }
      } catch (error) {
        console.error('Error loading lab statuses from Firestore:', error);
      }
    };

    loadLabStatuses();
  }, [user]);

  // Save lab status to Firestore when changed

  const handleAddLab = (e) => {
    e.preventDefault();
    if (labForm.week && labForm.group && labForm.title && labForm.pdfUrl) {
      setLabs([...labs, {
        id: Math.max(...labs.map(l => l.id), 0) + 1,
        ...labForm,
        week: parseInt(labForm.week)
      }]);
      setLabForm({ week: '', group: '', title: '', pdfUrl: '', status: 'closed' });
      setShowLabForm(false);
    }
  };

  // Save lab status to Firestore when changed
  const toggleLabStatus = async (id) => {
    setSavingLabId(id);
    const updatedLabs = labs.map(l => l.id === id ? { ...l, status: l.status === 'released' ? 'closed' : 'released' } : l);
    setLabs(updatedLabs);
    const lab = updatedLabs.find(l => l.id === id);
    
    console.log('Toggling lab:', id, 'New status:', lab.status);
    console.log('User ID:', user?.id);

    // Save to Firestore
    if (user && user.id) {
      try {        // Ensure the parent instructor document exists - this is critical for student queries
        const instructorRef = doc(db, 'instructors', user.id);
        await setDoc(instructorRef, { createdAt: new Date().toISOString(), updatedAt: new Date().toISOString() }, { merge: true });
                const statusRef = doc(db, 'instructors', user.id, 'labStatuses', 'statuses');
        console.log('Saving to Firestore path:', `instructors/${user.id}/labStatuses/statuses`);
        
        // Get existing statuses first
        const statusDoc = await getDoc(statusRef);
        const existingStatuses = statusDoc.exists() ? statusDoc.data() : {};
        
        const updateData = {
          ...existingStatuses,
          [`lab_${id}`]: lab.status,
          lastUpdated: new Date().toISOString()
        };
        
        console.log('Saving data:', updateData);
        
        // Update with new status
        await setDoc(statusRef, updateData);
        console.log('Successfully saved lab status:', lab.status);
        
        // Show success message
        setStatusMessage({
          type: 'success',
          title: `Lab ${lab.status === 'released' ? 'Released' : 'Closed'}`,
          message: `"${lab.title}" is now ${lab.status}`
        });
        
        setTimeout(() => setStatusMessage(null), 3000);
        
      } catch (error) {
        console.error('Error saving lab status to Firestore:', error);
        console.error('Error code:', error.code);
        console.error('Error message:', error.message);
        
        // Show error message
        setStatusMessage({
          type: 'error',
          title: 'Save Failed',
          message: error.message || 'Could not save lab status'
        });
        
        // Revert the change if save fails
        setLabs(labs);
        setTimeout(() => setStatusMessage(null), 4000);
      } finally {
        setSavingLabId(null);
      }
    } else {
      console.error('User not authenticated or UID not available');
      setStatusMessage({
        type: 'error',
        title: 'Not Authenticated',
        message: 'Please log in as an instructor'
      });
      setSavingLabId(null);
      setLabs(labs);
      setTimeout(() => setStatusMessage(null), 3000);
    }
  };

  // Get labs for current week
  const weekLabs = labs.filter(lab => lab.week === currentWeek);
  
  // Filter by group if needed
  const filteredLabs = filterGroup === 'all' 
    ? weekLabs 
    : weekLabs.filter(lab => lab.group === filterGroup);

  return (
    <div style={{ background: '#ffffff', minHeight: 'calc(100vh - 70px)', padding: '3rem 2rem' }}>
      {/* Status Message Modal */}
      {statusMessage && (
        <div style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          background: statusMessage.type === 'success' ? '#e8f5e9' : '#ffebee',
          border: `2px solid ${statusMessage.type === 'success' ? '#4caf50' : '#f44336'}`,
          borderRadius: '8px',
          padding: '1.5rem',
          maxWidth: '400px',
          zIndex: 1000,
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          animation: 'slideInBottom 0.3s ease'
        }}>
          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
            <div style={{ fontSize: '1.5rem' }}>
              {statusMessage.type === 'success' ? '✓' : '✕'}
            </div>
            <div>
              <h4 style={{ 
                margin: '0 0 0.5rem 0', 
                color: statusMessage.type === 'success' ? '#2e7d32' : '#c62828',
                fontWeight: 700
              }}>
                {statusMessage.title}
              </h4>
              <p style={{ margin: 0, color: statusMessage.type === 'success' ? '#1b5e20' : '#b71c1c', fontSize: '0.95rem' }}>
                {statusMessage.message}
              </p>
            </div>
          </div>
        </div>
      )}
      
      <style>{`
        @keyframes slideInBottom {
          from {
            transform: translateY(400px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
      `}</style>
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ marginBottom: '3rem', display: 'flex', alignItems: 'center', gap: '1rem', paddingBottom: '1.5rem', borderBottom: '2px solid #e8e8e8' }}>
          <button
            onClick={() => navigate('/dashboard')}
            style={{
              background: '#1a1a1a',
              border: 'none',
              color: 'white',
              padding: '0.6rem 0.8rem',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '1.1rem',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 300ms ease'
            }}
            onMouseOver={(e) => {
              e.target.style.background = '#2d2d2d';
              e.target.style.transform = 'scale(1.05)';
            }}
            onMouseOut={(e) => {
              e.target.style.background = '#1a1a1a';
              e.target.style.transform = 'scale(1)';
            }}
          >
            <i className="fas fa-arrow-left"></i>
          </button>
          <div>
            <h1 style={{ fontSize: '2.5rem', fontWeight: 700, color: '#1a1a1a', letterSpacing: '-1px', margin: '0' }}>
              <i className="fas fa-calendar-alt" style={{ marginRight: '1rem', color: '#1a1a1a' }}></i>
              Manage Weekly Labs
            </h1>
            <p style={{ fontSize: '1rem', color: '#666', margin: '0.5rem 0 0 0' }}>
              Manage lab PDFs for each week and group
            </p>
          </div>
        </div>

        {/* Week Selector and Add Button */}
        <div style={{ marginBottom: '2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
          {/* Week Selector */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <label style={{ fontWeight: 600, color: '#1a1a1a', fontSize: '1rem' }}>Select Week:</label>
            <select 
              value={currentWeek} 
              onChange={(e) => setCurrentWeek(parseInt(e.target.value))}
              style={{
                padding: '0.75rem 1rem',
                border: '1px solid #e8e8e8',
                borderRadius: '6px',
                fontFamily: 'inherit',
                fontSize: '1rem',
                background: 'white',
                color: '#1a1a1a',
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 300ms ease'
              }}
            >
              {weeks.map(week => (
                <option key={week} value={week}>Week {week} ({labs.filter(l => l.week === week).length} labs)</option>
              ))}
            </select>
          </div>

          {/* Filter by Group */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <label style={{ fontWeight: 600, color: '#1a1a1a', fontSize: '1rem' }}>Filter by Group:</label>
            <select 
              value={filterGroup} 
              onChange={(e) => setFilterGroup(e.target.value)}
              style={{
                padding: '0.75rem 1rem',
                border: '1px solid #e8e8e8',
                borderRadius: '6px',
                fontFamily: 'inherit',
                fontSize: '1rem',
                background: 'white',
                color: '#1a1a1a',
                fontWeight: 600,
                cursor: 'pointer',
                transition: 'all 300ms ease'
              }}
            >
              <option value="all">All Groups</option>
              {groups.map(group => (
                <option key={group} value={group}>{group}</option>
              ))}
            </select>
          </div>

          {/* Add Lab Button */}
          <button
            onClick={() => setShowLabForm(!showLabForm)}
            style={{
              background: '#1a1a1a',
              color: 'white',
              border: 'none',
              padding: '0.75rem 1.5rem',
              borderRadius: '6px',
              fontWeight: 600,
              cursor: 'pointer',
              fontSize: '0.95rem',
              transition: 'all 300ms ease'
            }}
            onMouseOver={(e) => e.target.style.opacity = '0.9'}
            onMouseOut={(e) => e.target.style.opacity = '1'}
          >
            {showLabForm ? '✕ Cancel' : '+ Add Lab PDF'}
          </button>
        </div>

        {/* Add Lab Form */}
        {showLabForm && (
          <div style={{
            background: '#f9f9f9',
            border: '2px solid #e8e8e8',
            borderRadius: '8px',
            padding: '2.5rem',
            marginBottom: '3rem'
          }}>
            <h2 style={{ fontSize: '1.25rem', fontWeight: 700, marginBottom: '1.5rem', color: '#1a1a1a' }}>
              Add Lab PDF for Week {currentWeek}
            </h2>
            <form onSubmit={handleAddLab}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.5rem', marginBottom: '1.5rem' }}>
                <div>
                  <label style={{ display: 'block', fontWeight: 600, marginBottom: '0.75rem', color: '#1a1a1a' }}>
                    Group
                  </label>
                  <select
                    value={labForm.group}
                    onChange={(e) => setLabForm({...labForm, group: e.target.value})}
                    style={{ 
                      width: '100%',
                      padding: '0.875rem 1rem',
                      border: '1px solid #e8e8e8',
                      borderRadius: '6px',
                      fontFamily: 'inherit',
                      fontSize: '1rem',
                      boxSizing: 'border-box',
                      background: 'white',
                      fontWeight: 600
                    }}
                  >
                    <option value="">-- Select Group --</option>
                    {groups.map(group => (
                      <option key={group} value={group}>{group}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label style={{ display: 'block', fontWeight: 600, marginBottom: '0.75rem', color: '#1a1a1a' }}>
                    Week
                  </label>
                  <input
                    type="number"
                    value={labForm.week || currentWeek}
                    onChange={(e) => setLabForm({...labForm, week: e.target.value})}
                    placeholder="e.g., 1"
                    min="1"
                    style={{ 
                      width: '100%',
                      padding: '0.875rem 1rem',
                      border: '1px solid #e8e8e8',
                      borderRadius: '6px',
                      fontFamily: 'inherit',
                      fontSize: '1rem',
                      boxSizing: 'border-box'
                    }}
                  />
                </div>
              </div>

              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ display: 'block', fontWeight: 600, marginBottom: '0.75rem', color: '#1a1a1a' }}>
                  Lab Title
                </label>
                <input
                  type="text"
                  value={labForm.title}
                  onChange={(e) => setLabForm({...labForm, title: e.target.value})}
                  placeholder="e.g., Foundation Concepts"
                  style={{ 
                    width: '100%',
                    padding: '0.875rem 1rem',
                    border: '1px solid #e8e8e8',
                    borderRadius: '6px',
                    fontFamily: 'inherit',
                    fontSize: '1rem',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div style={{ marginBottom: '1.5rem' }}>
                <label style={{ display: 'block', fontWeight: 600, marginBottom: '0.75rem', color: '#1a1a1a' }}>
                  PDF URL
                </label>
                <input
                  type="url"
                  value={labForm.pdfUrl}
                  onChange={(e) => setLabForm({...labForm, pdfUrl: e.target.value})}
                  placeholder="https://example.com/lab.pdf"
                  style={{ 
                    width: '100%',
                    padding: '0.875rem 1rem',
                    border: '1px solid #e8e8e8',
                    borderRadius: '6px',
                    fontFamily: 'inherit',
                    fontSize: '1rem',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div style={{ display: 'flex', gap: '1rem' }}>
                <button
                  type="submit"
                  style={{
                    background: '#1a1a1a',
                    color: 'white',
                    border: 'none',
                    padding: '0.875rem 1.75rem',
                    borderRadius: '6px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    fontSize: '1rem',
                    transition: 'all 300ms ease'
                  }}
                  onMouseOver={(e) => e.target.style.opacity = '0.9'}
                  onMouseOut={(e) => e.target.style.opacity = '1'}
                >
                  Add Lab
                </button>
                <button
                  type="button"
                  onClick={() => setShowLabForm(false)}
                  style={{
                    background: '#e8e8e8',
                    color: '#1a1a1a',
                    border: 'none',
                    padding: '0.875rem 1.75rem',
                    borderRadius: '6px',
                    fontWeight: 600,
                    cursor: 'pointer',
                    fontSize: '1rem',
                    transition: 'all 300ms ease'
                  }}
                  onMouseOver={(e) => e.target.style.opacity = '0.7'}
                  onMouseOut={(e) => e.target.style.opacity = '1'}
                >
                  Discard
                </button>
              </div>
            </form>
          </div>
        )}

        {/* Labs List */}
        <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '1.5rem' }}>
          {filteredLabs.length === 0 ? (
            <div style={{
              background: '#f9f9f9',
              border: '2px dashed #e8e8e8',
              borderRadius: '8px',
              padding: '3rem',
              textAlign: 'center'
            }}>
              <p style={{ fontSize: '1.1rem', color: '#666', margin: 0 }}>
                No labs found for this week and group combination.
              </p>
            </div>
          ) : (
            filteredLabs
              .sort((a, b) => groups.indexOf(a.group) - groups.indexOf(b.group))
              .map(lab => (
                <div
                  key={lab.id}
                  style={{
                    background: '#dcdcdc',
                    border: '1px solid #c0c0c0',
                    borderRadius: '8px',
                    padding: '1rem',
                    transition: 'all 300ms ease'
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.boxShadow = 'none';
                  }}
                >
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '2rem', alignItems: 'start' }}>
                    <div>
                      <h3 style={{ fontWeight: 700, margin: '0 0 1rem 0', color: '#1a1a1a', fontSize: '1.25rem' }}>
                        {lab.title}
                      </h3>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
                        <span style={{ color: '#666', fontSize: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          <i className="fas fa-layer-group"></i>
                          Week {lab.week} - {lab.group}
                        </span>
                        <span style={{
                          background: lab.status === 'released' ? '#e8f5e9' : '#ffebee',
                          color: lab.status === 'released' ? '#2e7d32' : '#c62828',
                          padding: '0.5rem 1rem',
                          borderRadius: '20px',
                          fontSize: '0.9rem',
                          fontWeight: 600
                        }}>
                          {lab.status === 'released' ? '● Released' : '● Closed'}
                        </span>
                      </div>
                      <a 
                        href={lab.pdfUrl} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '0.5rem',
                          color: '#1a1a1a',
                          textDecoration: 'none',
                          fontWeight: 600,
                          fontSize: '0.95rem'
                        }}
                      >
                        <i className="fas fa-file-pdf"></i>
                        View PDF
                      </a>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', minWidth: '150px' }}>
                      <button
                        onClick={() => toggleLabStatus(lab.id)}
                        disabled={savingLabId === lab.id}
                        style={{
                          background: savingLabId === lab.id ? '#dcdcdc' : (lab.status === 'released' ? '#e8e8e8' : '#1a1a1a'),
                          color: savingLabId === lab.id ? '#999' : (lab.status === 'released' ? '#1a1a1a' : 'white'),
                          border: 'none',
                          padding: '0.75rem 1.5rem',
                          borderRadius: '6px',
                          fontWeight: 600,
                          cursor: savingLabId === lab.id ? 'not-allowed' : 'pointer',
                          fontSize: '1rem',
                          transition: 'all 300ms ease',
                          opacity: savingLabId === lab.id ? 0.7 : 1
                        }}
                        onMouseOver={(e) => {
                          if (savingLabId !== lab.id) {
                            e.target.style.opacity = '0.9';
                          }
                        }}
                        onMouseOut={(e) => {
                          if (savingLabId !== lab.id) {
                            e.target.style.opacity = '1';
                          }
                        }}
                      >
                        {savingLabId === lab.id ? (
                          <>
                            <i className="fas fa-spinner fa-spin" style={{ marginRight: '0.5rem' }}></i>
                            Saving...
                          </>
                        ) : (
                          lab.status === 'released' ? 'Close Lab' : 'Release Lab'
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              ))
          )}
        </div>
      </div>
    </div>
  );
}
